/**
 * Regex to match the auto-generated live doc title format: "Untitled live doc YYYY-MM-DD"
 * or "Untitled live doc YYYY-MM-DD (n)" when multiple live docs are created on the same day.
 * This is the default title assigned by the backend when a new live doc is created.
 */
const DEFAULT_LIVE_DOC_TITLE_PATTERN = /^Untitled live doc \d{4}-\d{2}-\d{2}( \(\d+\))?$/;

/**
 * Returns true if the given title matches the auto-generated live doc title format
 * ("Untitled live doc YYYY-MM-DD"). Used to determine whether a title should be
 * suppressed in favour of showing the "New live doc" placeholder text.
 */
export const isDefaultLiveDocTitle = (title?: string | null): boolean => {
	if (!title) {
		return false;
	}
	return DEFAULT_LIVE_DOC_TITLE_PATTERN.test(title);
};
